import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/Icon'

import { globalHeader } from './styles'
import type { GlobalHeaderProps } from './types'

const GlobalHeader = (props: GlobalHeaderProps) => {
  const {
    container,
    contentWrapper,
    logoContainer,
    anchor,
    leftContainer,
    title,
    logoImg,
    wordMarkContainer,
  } = globalHeader()
  return (
    <View className={container()}>
      <View className={contentWrapper()}>
        <View className={leftContainer()}>
          <View className={anchor()}>
            <Pressable onPress={props.logoLink.onPress} className={leftContainer()}>
              <View className={logoContainer()}>
                {props.logo ?? (
                  <View className={anchor()}>
                    <Icon className={logoImg()} imgSrc={IMAGE.illustrations.logo_green_41x34} />
                  </View>
                )}
              </View>
              {!props.title ? (
                <View className={wordMarkContainer()}>
                  {props.wordMark ?? (
                    <Icon className={logoImg()} imgSrc={IMAGE.illustrations.logo_wordmark_130x16} />
                  )}
                </View>
              ) : null}
            </Pressable>
          </View>
          {props.title ? (
            <Text className={title()} role="heading" aria-level={1}>
              {props.title}
            </Text>
          ) : null}
        </View>

        <>{props.children}</>
      </View>
    </View>
  )
}

export default GlobalHeader
